import create from 'zustand';
import { getMoney } from '@/apis';

type MoneyInfo = NonNullable<Awaited<ReturnType<typeof getMoney>>['data']>;

interface MoneyStore {
  moneyInfo?: MoneyInfo;
  getMoney: () => Promise<MoneyInfo | undefined | null>;
}
export const useMoneyInfo = create<MoneyStore>((set) => ({
  async getMoney() {
    try {
      const res = await getMoney({});
      set({
        moneyInfo: res.data,
      });
      return res.data;
    } catch {
      return null;
    }
  },
}));
